namespace Matrix.Indexation {
    export interface CompositeConstituentRow {
        IndexationProfileCode?: string;
        CompositeIndexCode?: string;
        ConstituentIndexCode?: string;
        Weight?: number;
        HedgeRatio?: number;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IndexationProfileName?: string;
        IndexationProfileIndexationInstanceId?: string;
        IndexationProfileEffectiveDate?: string;
        IndexationProfileValidFrom?: string;
        IndexationProfileValidTo?: string;
        IndexationProfileShortName?: string;
        IndexationProfileRowId?: number;
        IndexationProfileDefaultSortOrder?: number;
        CompositeIndexName?: string;
        CompositeIndexLocalCurrencyCode?: string;
        CompositeIndexTypeCode?: string;
        CompositeIndexPriceSource1?: string;
        CompositeIndexPriceSource1Id?: string;
        CompositeIndexPriceSource2?: string;
        CompositeIndexPriceSource2Id?: string;
        CompositeIndexFxOtherCurrency?: string;
        CompositeIndexRowId?: number;
        CompositeIndexDefaultSortOrder?: number;
        ConstituentIndexName?: string;
        ConstituentIndexLocalCurrencyCode?: string;
        ConstituentIndexTypeCode?: string;
        ConstituentIndexPriceSource1?: string;
        ConstituentIndexPriceSource1Id?: string;
        ConstituentIndexPriceSource2?: string;
        ConstituentIndexPriceSource2Id?: string;
        ConstituentIndexFxOtherCurrency?: string;
        ConstituentIndexRowId?: number;
        ConstituentIndexDefaultSortOrder?: number;
    }

    export namespace CompositeConstituentRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.CompositeConstituent';
        export const deletePermission = 'Read:CompositeConstituent';
        export const insertPermission = 'Read:CompositeConstituent';
        export const readPermission = 'Read:CompositeConstituent';
        export const updatePermission = 'Read:CompositeConstituent';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            CompositeIndexCode = "CompositeIndexCode",
            ConstituentIndexCode = "ConstituentIndexCode",
            Weight = "Weight",
            HedgeRatio = "HedgeRatio",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IndexationProfileName = "IndexationProfileName",
            IndexationProfileIndexationInstanceId = "IndexationProfileIndexationInstanceId",
            IndexationProfileEffectiveDate = "IndexationProfileEffectiveDate",
            IndexationProfileValidFrom = "IndexationProfileValidFrom",
            IndexationProfileValidTo = "IndexationProfileValidTo",
            IndexationProfileShortName = "IndexationProfileShortName",
            IndexationProfileRowId = "IndexationProfileRowId",
            IndexationProfileDefaultSortOrder = "IndexationProfileDefaultSortOrder",
            CompositeIndexName = "CompositeIndexName",
            CompositeIndexLocalCurrencyCode = "CompositeIndexLocalCurrencyCode",
            CompositeIndexTypeCode = "CompositeIndexTypeCode",
            CompositeIndexPriceSource1 = "CompositeIndexPriceSource1",
            CompositeIndexPriceSource1Id = "CompositeIndexPriceSource1Id",
            CompositeIndexPriceSource2 = "CompositeIndexPriceSource2",
            CompositeIndexPriceSource2Id = "CompositeIndexPriceSource2Id",
            CompositeIndexFxOtherCurrency = "CompositeIndexFxOtherCurrency",
            CompositeIndexRowId = "CompositeIndexRowId",
            CompositeIndexDefaultSortOrder = "CompositeIndexDefaultSortOrder",
            ConstituentIndexName = "ConstituentIndexName",
            ConstituentIndexLocalCurrencyCode = "ConstituentIndexLocalCurrencyCode",
            ConstituentIndexTypeCode = "ConstituentIndexTypeCode",
            ConstituentIndexPriceSource1 = "ConstituentIndexPriceSource1",
            ConstituentIndexPriceSource1Id = "ConstituentIndexPriceSource1Id",
            ConstituentIndexPriceSource2 = "ConstituentIndexPriceSource2",
            ConstituentIndexPriceSource2Id = "ConstituentIndexPriceSource2Id",
            ConstituentIndexFxOtherCurrency = "ConstituentIndexFxOtherCurrency",
            ConstituentIndexRowId = "ConstituentIndexRowId",
            ConstituentIndexDefaultSortOrder = "ConstituentIndexDefaultSortOrder"
        }
    }
}
